import {
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';
import { Router } from '@angular/router';
import { AuthUser } from '../../models/auth-user.model';
import { AuthService } from '../../services/auth.service';
import { SidenavService } from '../../services/sidenav.service';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavComponent {
  @Input() user: AuthUser | null = null;
  @Input() isAdmin: boolean = false;
  @Input() version: string = '';

  constructor(
    private router: Router,
    private authService: AuthService,
    private sidenavService: SidenavService,
  ) {}

  goToPage(path: string): void {
    this.router.navigate([path], { replaceUrl: true });
    const sidenav = this.sidenavService.getSidenav();
    if (sidenav?.mode === 'over') {
      sidenav.close();
    }
  }

  logout(): void {
    this.authService.clean();
    this.sidenavService.getSidenav()?.close();
    this.router.navigate(['/login'], { replaceUrl: true });
  }
}
